import { TextProps } from "@chakra-ui/react";
import CDS from "design-system";

export default function AttributeColumnLabel({ children, ...rest }: TextProps) {
  return (
    <CDS.Text10
      fontWeight="600"
      textTransform="uppercase"
      color="content.tertiary"
      letterSpacing="wide"
      {...rest}
    >
      {children}
    </CDS.Text10>
  );
}
